import React from 'react';

import PropTypes from 'prop-types';

import { CarouselProvider, Slide, Slider } from 'pure-react-carousel';

import { useMatchMedia } from '../../../hooks/useMatchMedia';
import promoBreakpoints from '../../../theme/promoBreakpoints';

const MediaQuote = ({ data }) => {
    const isDesktop = useMatchMedia(promoBreakpoints.desktop1440);
    const dataArray = data && Object.entries(data);
    const totalSlides = dataArray ? dataArray.length : null;
    if (dataArray && dataArray.length > 0) {
        return (
            <section className="section-media-quotes">
                <div className="inner-content">
                    <div className="media-quotes-list" id="mediaQuotes" tabIndex="0">
                        <div className="flickity-viewport">
                            <CarouselProvider
                                naturalSlideHeight={176}
                                naturalSlideWidth="100%"
                                totalSlides={totalSlides}
                                visibleSlides={isDesktop ? 3 : 1}
                                isPlaying={!__isDev__}
                                isIntrinsicHeight
                            >
                                <Slider>
                                    {dataArray.map(([key, value], i) => {
                                        return (
                                            <Slide index={i} key={key}>
                                                <a className={`media-quote ${key}`} rel="noreferrer noopener nofollower" target="_blank" href={value.url}>
                                                    <div className="inner-content">
                                                        <p>{value.name}</p>
                                                    </div>
                                                </a>
                                            </Slide>
                                        );
                                    })}
                                </Slider>
                            </CarouselProvider>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
    return null;
};

MediaQuote.propTypes = {
    data: PropTypes.object,
};

export default MediaQuote;
